import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { MarketerPotentialDashboard } from '../../../features/marketer-potential'
import { MARKETER_POTENTIAL_COMBOS_IDS } from '../constants'
import { useCombos } from '../../../features/combos/hooks'

export const MarketerPotentialPage = () => {
  useCombos(MARKETER_POTENTIAL_COMBOS_IDS)

  return (
    <Routes>
      <Route exact path="" element={<MarketerPotentialDashboard />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  )
}
